export var LOGIN_REQUEST = "auth/loginRequest";
export var LOGOUT_REQUEST = "auth/logoutRequest";
export var CHECK_AUTH_REQUEST = "auth/checkAuthRequest";
export var UPDATE_USER_INFO = "auth/updateUserInfo";
